import { useQuery } from "@tanstack/react-query";
import {
    getClassRequestForTeacher,
    getFutureClassesForTeacher2,
    getNumberOfRescheduleRequestForTeacher,
    getPastClassesForTeacher,
} from "api/booking.api.js";

import { useAuth } from "context/AuthContext.jsx";
import { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { UpcomingClassCardInstructor } from "ui/base/class/UpcomingClassCardInstructor.jsx";
import { ChevronRight } from "ui/icons/ChevronRight.jsx";
import { CalendarTimeIcon } from "ui/icons/homeInstructor/CalendarTimeIcon";
import { ChatIcon } from "ui/icons/homeInstructor/ChatIcon";
import { DoughnutIcon } from "ui/icons/homeInstructor/DoughnutIcon";
import { ListEditIcon } from "ui/icons/homeInstructor/ListEditIcon";
import { MessagesIcon } from "ui/icons/homeInstructor/MessagesIcon";
import { defaultThemeColors, fonts, themeColor } from "ui/theme/index.js";
import { instructorRoute } from "../instructor.routes.jsx";
import { Financials } from "./section/Financials.jsx";
import { InstructorMessages } from "./section/instructorMessage/InstructorMessages.jsx";
import { LoaderComponent } from "ui/base/loading/LoaderComponent";
import { PastClasses } from "./section/PastClasses";
import { RequestedClasses } from "./section/requestedClasses/RequestedClasses.jsx";
import { UpcomingClasses } from "./section/upcomingClasses/UpcomingClasses.jsx";
import { StarFullIcon } from "ui/icons/StarFullIcon.jsx";
import { useUnreadMessageCount } from "services/firestore/getMessagesUnreadCountByUser.js";

const tabsItem = [
    { key: "requested", label: "Class request", icon: <MessagesIcon /> },
    { key: "upcoming", label: "Upcoming classes", icon: <CalendarTimeIcon /> },
    { key: "past", label: "Past classes", icon: <CalendarTimeIcon /> },
    { key: "listing", label: "Listing", icon: <ListEditIcon /> },
    { key: "messages", label: "Messages", icon: <ChatIcon /> },
    { key: "financials", label: "Financials", icon: <DoughnutIcon /> },
];

export const HomeInstructor = () => {
    const navigate = useNavigate();
    const { userData, userRole } = useAuth();
    const { state } = useLocation();

    const [activeTab, setActiveTab] = useState("requested");
    // For messages
    const [activeRequest, setActiveRequest] = useState(null);
    // Opening a chat marks it read, so the messages panel mounts only once the
    // instructor opens Messages; until then the unread badge stays visible.
    const [messagesOpened, setMessagesOpened] = useState(false);
    useEffect(() => {
        if (activeTab === "messages") setMessagesOpened(true);
    }, [activeTab]);

    useEffect(() => {
        getActiveTab(state);
    }, [state]);

    const isMobile = useMediaQuery({ query: "(max-width: 1024px)" });
    const [isMobileOverlayVisible, setMobileOverlayVisibility] = useState(false);

    const unreadMessagesCount = useUnreadMessageCount(userData?.id, userRole);

    const getActiveTab = (currentState) => {
        switch (currentState) {
            case "class_request_accepted":
                setActiveTab("requested");

                break;
            case "a_new_class_request":
                setActiveTab("upcoming");

                break;

            case "reschedule_request_accepted":
                setActiveTab("requested");
                break;

            case "reschedule_request_rejected":
                setActiveTab("requested");
                break;
            case "reschedulebooking_request":
                setActiveTab("upcoming");
                break;

            case "class_request_rejected":
                setActiveTab("past");
                break;
            default:
                setActiveTab("requested");
                break;
        }
    };

    const { data: requestedClasses, isLoading: isRequestedClassesLoading } =
        useQuery({
            queryKey: ["getClassRequestForTeacher"],
            queryFn: getClassRequestForTeacher,
        });

    const { data: numberRescheduledClasses } = useQuery({
        queryKey: ["getNumberOfRescheduleRequestForTeacher"],
        queryFn: getNumberOfRescheduleRequestForTeacher,
    });

    const { data: futureClasses, isLoading: isFutureClassesLoading } = useQuery({
        queryKey: ["getFutureClassesForTeacher2"],
        queryFn: getFutureClassesForTeacher2,
    });

    const { data: pastClasses, isLoading: isPastClassesLoading } = useQuery({
        queryKey: ["getPastClassesForTeacher"],
        queryFn: getPastClassesForTeacher,
    });

    const handleMenuItemClick = (tab) => {
        if (isMobile) {
            setMobileOverlayVisibility(true);
        }
        setActiveTab(tab.key);
    };

    const getTitleMobile = () => {
        switch (activeTab) {
            case "requested":
                return "Class Requests";
            case "upcoming":
                return "Upcoming Classes";
            case "past":
                return "Past Classes";
            case "messages":
                return "Messages";
            case "financials":
                return "Financials";
            default:
                break;
        }
    };

    if (userData?.teacher?.status === "awaiting") return (

        <>
            <ReviewListingMessageContainer>
                <ReviewListingPendingText>{"Your listing is being reviewed."}</ReviewListingPendingText>
            </ReviewListingMessageContainer>
        </>
    )

    return (
        <Container>
            <Sidebar>
                <Header>
                    <Greeting>Hi, {userData?.first_name}</Greeting>

                    <Rating>
                        <p>{userData?.teacher?.class?.title}</p>
                        <p className="rating">
                            <StarFullIcon />
                            {userData?.teacher_rating_avg || 0}
                        </p>
                        <p className="review">({userData?.teacher?.review || 0} {userData?.teacher?.review > 1 ? "reviews" : "review"})</p>
                    </Rating>
                </Header>

                {/* <MobileNavGridContainer> */}
                {tabsItem.map((tab) => (
                    <SidebarItem
                        key={tab.key}
                        active={activeTab === tab.key}
                        onClick={() =>
                            tab.key === "listing"
                                ? navigate(instructorRoute.classListing)
                                : handleMenuItemClick(tab)
                        }
                    >
                        <SidebarIcon>
                            {tab.icon}
                            {tab.label}
                        </SidebarIcon>

                        {tab.key === "requested" && requestedClasses?.data?.length ? (
                            <Badge>{requestedClasses?.data?.length}</Badge>
                        ) : null}
                        {tab.key === "upcoming" && !!numberRescheduledClasses?.data ? (
                            <Badge>{numberRescheduledClasses.data}</Badge>
                        ) : null}

                        {tab.key === "messages" && unreadMessagesCount ? (
                            <Badge>{unreadMessagesCount}</Badge>
                        ) : null}


                        <MobileWrapper>
                            <ChevronRight />
                        </MobileWrapper>
                    </SidebarItem>
                ))}
                {/* </MobileNavGridContainer> */}
            </Sidebar>

            <MobileOverlay isVisible={isMobileOverlayVisible}>
                <OverlayContent>
                    {activeTab != "messages" && <OverlayHeader>
                        <CloseButton onClick={() => setMobileOverlayVisibility(false)
                        }>
                            <ChevronRight
                                style={{
                                    transform: "rotate(180deg)",
                                }}
                            />
                        </CloseButton>
                        <h2>{getTitleMobile()}</h2>
                    </OverlayHeader>}

                    <OverlayBody>
                        <SharedContent
                            userData={userData}
                            activeTab={activeTab}
                            requestedClasses={requestedClasses}
                            futureClasses={futureClasses}
                            pastClasses={pastClasses}
                            setActiveTab={setActiveTab}
                            isRequestedClassesLoading={isRequestedClassesLoading}
                            isFutureClassesLoading={isFutureClassesLoading}
                            isPastClassesLoading={isPastClassesLoading}
                            setMobileOverlayVisibility={setMobileOverlayVisibility}
                            setActiveRequest={setActiveRequest}
                            activeRequest={activeRequest}
                            messagesOpened={messagesOpened}
                        />
                    </OverlayBody>
                </OverlayContent>
            </MobileOverlay>
            <SharedContent
                hide
                userData={userData}
                activeTab={activeTab}
                requestedClasses={requestedClasses}
                futureClasses={futureClasses}
                pastClasses={pastClasses}
                setActiveTab={setActiveTab}
                isRequestedClassesLoading={isRequestedClassesLoading}
                isFutureClassesLoading={isFutureClassesLoading}
                isPastClassesLoading={isPastClassesLoading}
                setActiveRequest={setActiveRequest}
                activeRequest={activeRequest}
                messagesOpened={messagesOpened}
            />

            {futureClasses?.length ? (
                <MobileNextLessonsContainer>
                    {futureClasses?.slice(0, 3).map((futureClasse) => (
                        <UpcomingClassCardInstructor
                            key={futureClasse.id}
                            upcomingClass={futureClasse}
                            acceptReschedule={(upcomingClass) => mutate(upcomingClass)}
                            rejectReschedule={(upcomingClass) => mutate(upcomingClass)}
                            sendMessage={onSendMessage}
                            onCancel={() => {
                                setSelectedBooking(futureClasse);
                                setShowCancelModal(true);
                            }}
                        />
                    ))}
                </MobileNextLessonsContainer>
            ) : null}
        </Container>
    );
};
const SharedContent = ({
    hide,
    userData,
    activeTab,
    requestedClasses,
    futureClasses,
    pastClasses,
    setActiveTab,
    isRequestedClassesLoading,
    isFutureClassesLoading,
    isPastClassesLoading,
    setMobileOverlayVisibility,
    activeRequest,
    setActiveRequest,
    messagesOpened,
}) => {
    return (
        <Content hide={hide}>
            <SidebarContent active={activeTab === "requested"}>
                {isRequestedClassesLoading ? (
                    <LoadingContainer>
                        <LoaderComponent minHeight="auto" />
                    </LoadingContainer>
                ) : (
                    <RequestedClasses
                        requestedClasses={requestedClasses?.data || []}
                        classType={userData?.teacher?.class?.title || ""}
                        onSendMessage={(id) => {
                            setActiveRequest(id)
                            setActiveTab("messages")
                        }}
                    />
                )}
            </SidebarContent>
            <SidebarContent active={activeTab === "upcoming"}>
                {isFutureClassesLoading ? (
                    <LoadingContainer>
                        <LoaderComponent minHeight="auto" />
                    </LoadingContainer>
                ) : (
                    <UpcomingClasses
                        futureClasses={futureClasses?.data || []}
                        onSendMessage={(id) => {
                            setActiveRequest(id)
                            setActiveTab("messages")
                        }}
                    />
                )}
            </SidebarContent>
            <SidebarContent active={activeTab === "past"}>
                {isPastClassesLoading ? (
                    <LoadingContainer>
                        <LoaderComponent minHeight="auto" />
                    </LoadingContainer>
                ) : (
                    <PastClasses pastClasses={pastClasses?.data || []} onSendMessage={(id) => {
                        setActiveRequest(id)
                        setActiveTab("messages")
                    }} />
                )}
            </SidebarContent>
            <SidebarContent active={activeTab === "messages"}>
                {messagesOpened && (
                    <InstructorMessages setMobileOverlayVisibility={setMobileOverlayVisibility} activeRequest={activeRequest} />
                )}
            </SidebarContent>
            <SidebarContent active={activeTab === "financials"}>
                <Financials />
            </SidebarContent>
        </Content>
    );
};

const Container = styled.div`
    position: relative;
    z-index: 0;
    max-width: 1300px;
    margin-inline: auto;

    padding-bottom: 2rem;

    display: flex;
    flex-direction: column;
    gap: 3rem;
    font-family: var(--font-secondary);
    height: var(--page-height);
    overflow: auto;

    @media (min-width: 768px) {
        height: var(--page-height);
    }

    @media (min-width: 660px) {
        height: var(--page-height);
    }

    @media (min-width: 1200px) {
        height: var(--page-height);
    }

    @media (min-width: 1024px) {
        height: var(--page-height);
        padding-top: 60px;
        padding-inline: 2rem;
        flex-direction: row;
    }
`;

const Sidebar = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 300px;

    & > button:last-child {
        border-bottom: 2px solid ${defaultThemeColors.lightBlue};
    }
`;

const SidebarItem = styled.button`
    font-family: var(--font-secondary);
    background: transparent;
    color: ${({ active }) =>
        active ? defaultThemeColors.blue : defaultThemeColors.txt};
    border: none;
    padding-inline: 1rem;
    padding-block: 1rem;
    text-align: left;
    cursor: pointer;
    font-size: ${fonts.sizes.regular};
    font-weight: 600;
    border-top: 2px solid ${defaultThemeColors.lightBlue};
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;

    width: auto;

    /* @media (max-width: 1024px) {
      background-color: #f0f4ff;
      border-radius: 12px;
      padding: 20px 15px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
      cursor: pointer;
      min-height: 120px;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
      transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    } */
`;

const SidebarIcon = styled.div`
    display: flex;
    align-items: center;
    gap: 1rem;

    & > svg {
        color: ${defaultThemeColors.placeholder};

            /* @media (max-width: 1024px) {
      color: ${themeColor("blue")};
    } */
    }

    /* @media (max-width: 1024px) {
      flex-direction: column;
    } */
`;

const Header = styled.div`
    padding-inline: 1rem;
    padding-bottom: 1rem;
    margin-top: -1px;
    width: 100vw;

    /* height: 170px; */
    background-color: ${themeColor("blue")};

    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;

    @media (min-width: 1024px) {
        padding-bottom: 4rem;
        background-color: ${themeColor("white")};
        width: auto;
        height: auto;
    }
`;

const Greeting = styled.p`
    font-size: ${fonts.sizes.h3};
    font-weight: 600;
    margin-bottom: 5px;
    color: ${themeColor("white")};

    @media (min-width: 1024px) {
        color: ${themeColor("black")};
    }
`;

const Role = styled.span`
    font-size: ${fonts.sizes.medium};
    color: ${defaultThemeColors.txt};
    opacity: 0.7;
`;

const Rating = styled.div`
    font-size: ${fonts.sizes.medium};
    color: ${defaultThemeColors.txt};
    font-weight: 600;
    display: flex;
    align-items: center;
    gap: 0.5rem;

    & > .rating {
        display: flex;
        align-items: center;
        gap: 0.2rem;
        color: ${defaultThemeColors.pink};

        & > svg {
            width: 1.2rem;
            height: 1.2rem;
        }
    }

    & > .review {
        color: ${themeColor("white")};

        @media (min-width: 1024px) {
            color: ${defaultThemeColors.txt};
        }
        opacity: 0.6;
    }

    color: ${themeColor("white")};

    @media (min-width: 1024px) {
        color: ${themeColor("black")};
    }
`;

const Badge = styled.span`
    background: ${defaultThemeColors.blue};
    color: ${defaultThemeColors.white};
    padding: 3px 8px;
    border-radius: 12px;
    font-size: 12px;
    margin-right: auto;
`;

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;

    margin-left: 1rem;
    margin-right: 1rem;

    @media (min-width: 1024px) {
        overflow: hidden;
        margin-left: 0rem;
        margin-right: 0rem;
    }

    @media (max-width: 1023px) {
        display: ${({ hide }) => (hide ? "none" : "flex")};
    }
`;

const SidebarContent = styled.div`
    display: ${({ active }) => (active ? "flex" : "none")};
    flex-grow: 1;
    flex: 1;
    height: 100%;
    flex-direction: column;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
`;

const MobileNavGridContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 300px;

    @media (max-width: 1024px) {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        padding: 20px;
        margin-top: -6rem;
    }
`;

const LoadingContainer = styled.div`
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: center;
    align-content: center;
    text-align: center;
`;

const MobileWrapper = styled.div`
    display: block;

    @media (max-width: 1024px) {
        ${(props) =>
        props.hide &&
        `
      display: none;
    `}
    }
`;

const MobileOverlay = styled.div`
    background-color: ${defaultThemeColors.white};
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${(props) => (props.isVisible ? "90%" : "0")};
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    transition: height 0.3s ease-in-out;

    overflow: hidden;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;

    @media (min-width: 1024px) {
        display: none;
    }
`;

const OverlayContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

const OverlayHeader = styled.div`
    display: flex;
    justify-content: flex-start;
    gap: 2rem;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid #eee;

    h2 {
        margin: 0;
        font-size: 1.2rem;
        color: #333;
    }
`;

const CloseButton = styled.button`
    background: none;
    cursor: pointer;
    align-items: center;
    justify-content: center;
    align-content: center;

    padding: 0.5rem;
    border: 1px solid ${themeColor("mobileInputBorder")};
    border-radius: 6px;
`;

const OverlayBody = styled.div`
    flex: 1;
    padding: 16px;
    overflow-y: auto;
`;

const MobileNextLessonsContainer = styled.div``;

const ReviewListingMessageContainer = styled.div`
    align-items: center;
    justify-content: center;
    align-content: center;
    height: var(--page-height);

    @media (min-width: 768px) {
        height: var(--page-height);
    }

    @media (min-width: 660px) {
        height: var(--page-height);
    }

    @media (min-width: 1200px) {
        height: var(--page-height);
    }

    @media (min-width: 1024px) {
        height: var(--page-height);
        padding-top: 60px;
        padding-inline: 2rem;
        flex-direction: row;
    }
`

const ReviewListingPendingText = styled.p`
text-align: center;
`
